module.exports = __webpack_public_path__ + "static/media/bachelor_member.a3b40c60.png";